// The regexp is borrowed from moment.
// https://github.com/moment/moment/blob/develop/src/lib/duration/create.js#L16
const regex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/

module.exports = function() {
  return value => {
    if (!value) return false
    return regex.test(value)
  }
}
